
export enum TimeRangeTypes {
    TODAY = "TODAY",
    //minutes
    PAST_MINUTE = "PAST_MINUTE",
    PAST_THREE_MINUTES = "PAST_THREE_MINUTES",
    PAST_FIVE_MINUTES = "PAST_FIVE_MINUTES",
    PAST_TEN_MINUTES = "PAST_TEN_MINUTES",
    PAST_FIFTEEN_MINUTES = "PAST_FIFTEEN_MINUTES",
    PAST_THIRTY_MINUTES = "PAST_THIRTY_MINUTES",
    //hours
    PAST_ONE_HOUR = "PAST_ONE_HOUR",
    PAST_THREE_HOURS = "PAST_THREE_HOURS",
    PAST_SIX_HOURS = "PAST_SIX_HOURS",
    PAST_TWELVE_HOURS = "PAST_TWELVE_HOURS",
    PAST_TWENTY_FOUR_HOURS = "PAST_TWENTY_FOUR_HOURS",
    //days
    PAST_THREE_DAYS = "PAST_THREE_DAYS",
    PAST_SEVEN_DAYS = "PAST_SEVEN_DAYS",
    PAST_FOURTEEN_DAYS = "PAST_FOURTEEN_DAYS",
    PAST_THIRTY_DAYS = "PAST_THIRTY_DAYS",
    PAST_NINETY_DAYS = "PAST_NINETY_DAYS",
    //months
    CURRENT_MONTH = "CURRENT_MONTH",
    LAST_MONTH = "LAST_MONTH",
    //quarters
    CURRENT_QUARTER = "CURRENT_QUARTER",
    LAST_QUARTER = "LAST_QUARTER",
    //years
    CURRENT_YEAR = "CURRENT_YEAR",
    LAST_YEAR = "LAST_YEAR",
    CUSTOM = "CUSTOM"
}